import Vue from 'vue'
import i18n from './vuei18n'
import fieldType from '@/enums/fieldType'

function pad (num, size = 2) {
  var s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

Vue.filter('timestampToDate', timestamp => {
  if (Number.isInteger(Number(timestamp))) {
    let d = new Date(timestamp * 1000)
    let year = d.getFullYear()
    let month = pad(d.getMonth() + 1)
    let day = pad(d.getDate())
    return year + '-' + month + '-' + day
  }
})

Vue.filter('notEmpty', value => {
  return value || i18n.t('base.no-data')
})

function numberToTime (number) {
  if (!number) {
    return i18n.t('base.no-data')
  }
  var hours = Math.floor(number / 3600)
  var minutes = Math.floor((number - (hours * 3600)) / 60)
  var seconds = number - (hours * 3600) - (minutes * 60)

  if (hours < 10) { hours = '0' + hours }
  if (minutes < 10) { minutes = '0' + minutes }
  if (seconds < 10) { seconds = '0' + seconds }
  return hours + ':' + minutes + ':' + seconds
}

Vue.filter('numberToTime', number => {
  return numberToTime(number)
})

function dateFromDateTime (dateTime) {
  if (!dateTime) {
    return i18n.t('base.no-data')
  }
  let d = new Date(dateTime.replace(/-/g, '/'))
  if (isNaN(d)) {
    return ''
  }
  let year = d.getFullYear()
  let month = pad(d.getMonth() + 1)
  let day = pad(d.getDate())
  return year + '-' + month + '-' + day
}

Vue.filter('dateFromDateTime', dateTime => {
  return dateFromDateTime(dateTime)
})

Vue.filter('shortcut', text => {
  if (!text) return ''
  text = text.toString()
  if (text.length <= 24) return text
  let arr = text.slice(0, 24).split(' ')
  if (arr.length > 2) {
    arr = arr.slice(0, -1)
  }
  return arr.join(' ') + '...'
})

Vue.filter('field', (value, type) => {
  switch (type) {
    case fieldType.TIME : return numberToTime(value)
    case fieldType.DATE : return dateFromDateTime(value)
    case fieldType.MULTIPLE : return (value) ? value.join('; ') : i18n.t('base.no-data')
    default: return value || i18n.t('base.no-data')
  }
})

Vue.filter('intToYesNo',int => int == 0 ? i18n.t('no') : i18n.t('yes'))
